(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    const thumbnails = document.querySelector(".slideshow-controls__thumbnails-container");
  const activeClass = 'slideshow-controls__thumbnails-container--mousedown';
  let isDown = false;
  let startX, scrollLeft;
  let isDragging = false;
  
  if(!thumbnails) return;

  thumbnails.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - thumbnails.offsetLeft;
    scrollLeft = thumbnails.scrollLeft;
  });
  
  thumbnails.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - thumbnails.offsetLeft;
    const walk = (x - startX) * 2;
    thumbnails.classList.add(activeClass);
    thumbnails.scrollLeft = scrollLeft - walk;
  });

  ["mouseleave", "mouseup"].forEach(event => thumbnails.addEventListener(event, () => {
    isDown = false;
    thumbnails.classList.remove(activeClass);
  }));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_variant-details"] && !Shopify.designMode) return;
  try {
    const variantButtons = document.querySelectorAll('.js-spec-variant-btn');
  const variantTables = document.querySelectorAll('.js-spec-variant-table');

  variantButtons.forEach(button => {
    button.addEventListener('click', () => {
      const variantId = button.getAttribute('data-specs-variant-id');

      variantButtons.forEach(btn => {
        btn.classList.toggle('is-active', btn === button);
      });

      variantTables.forEach(table => {
        const isActive = table.getAttribute('data-specs-variant-id') === variantId;
        table.style.display = isActive ? 'block' : 'none';
        table.classList.toggle('is-active', isActive);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
